import React from "react";
import { Redirect, Route } from "react-router-dom";

import { useProfile } from "../Components/Hooks/UserHooks";
import useLogin from "../hooks/useLogin";

const AuthProtected = (props) => {
  const { userProfile, loading } = useProfile();
  const loginHook = useLogin()
  /*
    redirect is un-auth access protected routes via url
    */

  if (!userProfile && loading) {
    loginHook.ToLogin()
    // return (
    //   <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
    // );
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
